import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MasterDataService } from '../../services/master-data.service';

@Component({
  selector: 'app-my-holidays',
  templateUrl: './my-holidays.component.html',
  styleUrls: ['./my-holidays.component.css']
})
export class MyHolidaysComponent implements OnInit {
  branchId;
  branchName;
  selectYear;
  financialYearList;
  holidayList;
  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    this.branchName = localStorage.getItem('branchName');
    this.branchId = localStorage.getItem('branchId');
    this.loadYearDetails();
  }

  loadYearDetails() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log("years :", res);
        this.financialYearList = res;
        var fyIndex = -1;
        this.financialYearList.forEach((element, key) => {
          var startDate = new Date(element.startDate);
          var endDate = new Date(element.endDate);
          var currentDate = moment(new Date()).format("YYYY-MM-DD");
          console.log(startDate, endDate);;
          console.log(currentDate + " " + element.startDate + " " + element.endDate);
          if (currentDate >= element.startDate && currentDate <= element.endDate) {
            fyIndex = key;
          }
          console.log("fyIndex", fyIndex)
        });
        console.log("financialYearList[fyIndex]", this.financialYearList[fyIndex])
        this.selectYear = this.financialYearList[fyIndex];
        console.log("this.selectedFY", this.selectYear);
        this.getHolidayData();
      });
  }

  getHolidayData() {
    console.log('branch name', this.branchName)
    this.masterDataService.getHolidaysReportDetails(this.branchId, this.selectYear.id).subscribe((resp: any) => {
      console.log('holiday data', resp);
      this.holidayList = resp;
    });
  }
}
